import sentry from 'src/js/modules/analytics/sentry';

const errorCatcher = (error, errorInfo) => {
  console.error(error);

  if (sentry.instance.isInit()) {
    sentry.instance.captureException(error, errorInfo);
  }
};

export default errorCatcher;
